import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {useOutletContext} from "react-router-dom";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import MerchantSkeleton from "../skeletons/MerchantSkeleton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPenToSquare} from "@fortawesome/free-solid-svg-icons";
import MerchantAutoConversion from "./MerchantAutoConversion";
import {formatAccount} from "../../features/ValueFormater";
import RenderKeyValuePairs from "./RenderKeyValuePairs";
import ImagesInput from "./ImagesInput";

function MerchantDetails({merchant, merchantLoading}) {
    const {LimitPerTransactionInUSD, LimitPerTransactionInLBP, ...generalInfo} = merchant.MerchantGeneralInfo;
    const {LogoImage, CoverImage, ...profile} = merchant.MerchantProfile;
    const [editMode, setEditMode] = useState(false);
    const [payload, setPayload] = useState({
        MerchantID: merchant.MerchantID,
        LimitPerTransactionInUSD: LimitPerTransactionInUSD,
        LimitPerTransactionInLBP: LimitPerTransactionInLBP,
        NewCoverImage: null,
        NewLogoImage: null,
        MerchantDisplayedName: profile.MerchantDisplayedName,
        Website: profile.Website,
        FacebookAccount: profile.Facebook,
        InstagramAccount: profile.Instagram
    });

    useEffect(() => {
        setEditMode(false);
    } , [merchant]);

    const dispatch = useDispatch();

    const [onOpenQrAfterGenerate]= useOutletContext();

    const handleSave = () => {
        setEditMode(false);

        dispatch(setActionType(ACTION_TYPES.EDIT_MERCHANT_INFO));
        dispatch(setActionPayload(payload));

        onOpenQrAfterGenerate();
    }

    return (
        <div className="merchant-details">
            {merchantLoading ? (
                <>
                    <MerchantSkeleton/>
                    <MerchantSkeleton/>
                </>
            ) : (
                <>
                    <div className="row mt-4">
                        <div className="col-12 title">MERCHANT INFORMATION</div>
                    </div>

                    <RenderKeyValuePairs obj={generalInfo}/>

                    {(sessionStorage.getItem("EntityType") === "LEGALENTITY" && sessionStorage.getItem("EntityRole").includes("ADMIN")) &&
                        <div className="row mt-5">
                            <div className="col-12 title title-edit">MERCHANT SETTINGS
                                <div className="edit-icon">
                                    {
                                        !editMode ?
                                            <button onClick={() => {
                                                setEditMode(true);
                                            }}><FontAwesomeIcon icon={faPenToSquare}/></button>
                                            :
                                            <button className="save-btn" onClick={handleSave}>Save</button>
                                    }
                                </div>
                            </div>
                            <MerchantAutoConversion MerchantAccountID={merchant?.MerchantID}
                                                    isChecked={generalInfo?.IsAutoExchangeOn}/>

                            {!editMode ?
                                <div className="mt-4">
                                    <div className="row rowCont">
                                        <div className="col-2 subTitle">Limit Per Transaction (USD)</div>
                                        <div className="col-9 desc">{formatAccount(LimitPerTransactionInUSD, 1)}</div>
                                    </div>

                                    <div className="row rowCont">
                                        <div className="col-2 subTitle">Limit Per Transaction (LBP)</div>
                                        <div className="col-9 desc">{formatAccount(LimitPerTransactionInLBP, 2)}</div>
                                    </div>
                                </div>
                                :
                                <div className="mt-4">
                                    <div className="row rowCont">
                                        <div className="col-2 subTitle">Limit Per Transaction (USD)</div>
                                        <div className="col-9 desc">
                                            <input type="text" value={payload.LimitPerTransactionInUSD}
                                                   onChange={(e) => {
                                                       setPayload({
                                                           ...payload,
                                                           LimitPerTransactionInUSD: e.target.value
                                                       });
                                                   }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row rowCont">
                                        <div className="col-2 subTitle">Limit Per Transaction (LBP)</div>
                                        <div className="col-9 desc">
                                            <input type="text" value={payload.LimitPerTransactionInLBP}
                                                   onChange={(e) => {
                                                       setPayload({
                                                           ...payload,
                                                           LimitPerTransactionInLBP: e.target.value
                                                       });
                                                   }}
                                            />
                                        </div>
                                    </div>

                                </div>
                            }
                        </div>
                    }

                            <div className="row my-5">
                                <div className="col-12 title">MERCHANT PROFILE
                                    {
                                        sessionStorage.getItem("EntityType") === "MERCHANTEMPLOYEE" &&
                                        <div className="edit-icon">
                                            {
                                                !editMode ?
                                                    <button onClick={() => {
                                                        setEditMode(true);
                                                    }}><FontAwesomeIcon icon={faPenToSquare}/></button>
                                                    :
                                                    <button className="save-btn" onClick={handleSave}>Save</button>
                                            }
                                        </div>
                                    }

                                </div>
                                {
                                    !editMode ?
                                        <>
                                            <div className="photos">
                                                <div className="row">
                                                    <div className="col-4 p-3">
                                                        <div className=" photo logo">
                                                            <img src={LogoImage} alt=""/>
                                                        </div>
                                                    </div>
                                                    <div className="col-8 p-3">
                                                        <div className="cover photo">
                                                            <img src={CoverImage} alt=""/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <RenderKeyValuePairs obj={profile}/>
                                        </>
                                        :
                                        <>
                                            <ImagesInput payload={payload} setPayload={setPayload}/>

                                            <div className="row rowCont">
                                                <div className="col-2 subTitle">Merchant Displayed Name</div>
                                                <div className="col-9 desc">
                                                    <input type="text" value={payload.MerchantDisplayedName}
                                                           onChange={(e) => {
                                                               setPayload({
                                                                   ...payload,
                                                                   MerchantDisplayedName: e.target.value
                                                               });
                                                           }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row rowCont">
                                                <div className="col-2 subTitle">Website</div>
                                                <div className="col-9 desc">
                                                    <input type="text" value={payload.Website}
                                                           onChange={(e) => {
                                                               setPayload({
                                                                   ...payload,
                                                                   Website: e.target.value
                                                               });
                                                           }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row rowCont">
                                                <div className="col-2 subTitle">Facebook</div>
                                                <div className="col-9 desc">
                                                    <input type="text" value={payload.FacebookAccount}
                                                           onChange={(e) => {
                                                               setPayload({
                                                                   ...payload,
                                                                   FacebookAccount: e.target.value
                                                               });
                                                           }
                                                           }
                                                    />
                                                </div>
                                            </div>
                                            <div className="row rowCont">
                                                <div className="col-2 subTitle">Instagram</div>
                                                <div className="col-9 desc">
                                                    <input type="text" value={payload.InstagramAccount}
                                                           onChange={(e) => {
                                                               setPayload({
                                                                   ...payload,
                                                                   InstagramAccount: e.target.value
                                                               });
                                                           }}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                }
                            </div>

                </>
            )}
        </div>
    );
}

export default MerchantDetails;